import { useState } from "react"
import { FOCO } from "./foco"

export const Copiar = ({ valor, rotulo }: { valor: string; rotulo: string }) => {
    const [copiado, setCopiado] = useState(false)

    const copiar = async () => {
        try {
            await navigator.clipboard.writeText(valor)
            setCopiado(true)
        } catch {
            setCopiado(false)
        }
    }

    return (
        <button
            type="button"
            aria-label={rotulo}
            onClick={() => void copiar()}
            className={`rounded-full border border-line-strong px-3 py-1 text-xs font-semibold text-ink hover:bg-sunk ${FOCO}`}
        >
            <span aria-live="polite">{copiado ? "Copiado" : "Copiar"}</span>
        </button>
    )
}

// O serviço manda a data pronta (dd/MM/aaaa) ou em ISO; a tela aceita as duas.
export const dataCurta = (data: string) => {
    const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(data)
    return iso ? `${iso[3]}/${iso[2]}` : data.slice(0, 5)
}

export const dataCompleta = (data: string) => {
    const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(data)
    return iso ? `${iso[3]}/${iso[2]}/${iso[1]}` : data
}
